import { Component } from '@opten/compiler/metadata/component';
import { scrollToElement } from '@opten/scroll/scroll-to-element';
import { getSelectorElementFromElement } from '@opten/dom/get-selector-element-from-element';

@Component({ className: 'js-scroll-to' })
export class ScrollToComponent {
	private navbar: HTMLElement;

	constructor(private element: HTMLElement) {
		this.navbar = document.getElementsByClassName(
			'js-navbar-height'
		)[0] as HTMLElement;

		element.addEventListener('click', (e) => {
			e.preventDefault();
			const target = getSelectorElementFromElement(element);
			const offsetString = element.getAttribute('data-offset');
			let offset =
				offsetString === 'targetHeight'
					? target.clientHeight
					: parseInt(offsetString || '0', 0);
			if (isNaN(offset)) {
				offset = 0;
			}
			if (offset === 0) {
				offset = this.navbar ? this.navbar.clientHeight * -1 : 0;
			}
			scrollToElement(target, undefined, undefined, offset);
		});
	}
}
